import React from 'react';
import { Landmark, User, Hash, IndianRupee, CreditCard } from 'lucide-react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';

const PaymentDetails = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      {/* Hero */}
      <div className="relative h-[30vh] flex items-center">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1601597111158-2fceff292cdc?w=1920"
            alt="Payment Details"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/60" />
        </div>

        <div className="relative max-w-7xl mx-auto px-6 pt-16">
          <h1 className="text-4xl font-bold text-white mb-2">
            Payment Details
          </h1>
          <p className="text-white/80">
            Use the following bank details to complete your payment
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-16">
        <div className="bg-white rounded-3xl shadow-lg p-8 space-y-6">

          <h2 className="text-2xl font-bold text-gray-900 mb-6">
            Bank Account Information
          </h2>

          {/* Account Holder */}
          <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-2xl">
            <div className="p-3 bg-emerald-100 rounded-xl">
              <User className="h-6 w-6 text-emerald-600" />
            </div>
            <div>
              <p className="font-semibold text-gray-900">Account Holder Name</p>
              <p className="text-gray-600">MAGIC MOUNTAIN</p>
            </div>
          </div>

          {/* Bank Name */}
          <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-2xl">
            <div className="p-3 bg-emerald-100 rounded-xl">
              <Landmark className="h-6 w-6 text-emerald-600" />
            </div>
            <div>
              <p className="font-semibold text-gray-900">Bank Name</p>
              <p className="text-gray-600">BANK OF BARODA</p>
            </div>
          </div>

          {/* Account Number */}
          <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-2xl">
            <div className="p-3 bg-emerald-100 rounded-xl">
              <Hash className="h-6 w-6 text-emerald-600" />
            </div>
            <div>
              <p className="font-semibold text-gray-900">Account Number</p>
              <p className="text-gray-600">32080200000221</p>
            </div>
          </div>

          {/* IFSC */}
          <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-2xl">
            <div className="p-3 bg-emerald-100 rounded-xl">
              <CreditCard className="h-6 w-6 text-emerald-600" />
            </div>
            <div>
              <p className="font-semibold text-gray-900">IFSC Code</p>
              <p className="text-gray-600">BARB0MANALI</p>
            </div>
          </div>

          <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-2xl">
            <div className="p-3 bg-emerald-100 rounded-xl">
              <CreditCard className="h-6 w-6 text-emerald-600" />
            </div>
            <div>
              <p className="font-semibold text-gray-900">SWIFT CODE</p>
              <p className="text-gray-600">BARBINBBCHD</p>
            </div>
          </div>


          {/* Amount Note */}
          <div className="flex items-start gap-4 p-4 bg-emerald-50 rounded-2xl border border-emerald-200">
            <div className="p-3 bg-emerald-100 rounded-xl">
              <IndianRupee className="h-6 w-6 text-emerald-600" />
            </div>
            <div>
              <p className="font-semibold text-gray-900">Payment Note</p>
              <p className="text-gray-600">
                Please mention your <strong>Name & Tour Date</strong> in the payment reference.
              </p>
            </div>
          </div>

        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PaymentDetails;
